import { clsx } from '@alexis/helpers/clsx';
import { useFlightSearchResults } from '@pages/FlightSearchResult/contexts/FlightSearchResultsContext';
import useFlightSearchFilters from '@pages/FlightSearchResult/hooks/useFlightSearchFilters';
import { useSelector } from 'react-redux';

import { renderLegLabel } from '@helpers/flight';

import { getIsRtlState, getTranslationsState } from '@redux/selectors';

import styles from '../FlightFilters.module.scss';

const MultiCityLegSelector: React.FC = () => {
  const { activeLeg, setActiveLeg } = useFlightSearchFilters();

  const { legFilterOptions } = useFlightSearchResults();

  const translations = useSelector(getTranslationsState);
  const isRtl = useSelector(getIsRtlState);

  return (
    <div className={styles.legSelector}>
      <div className={styles.legSelectorLabel}>{translations.flight_legs}:</div>

      <div className={styles.subHeader}>{translations.applicable_only_for_this_trip}</div>

      <div className={styles.multiCity}>
        {legFilterOptions.map((leg, index) => (
          <div
            key={index}
            className={clsx(styles.multiCityItem, activeLeg === index && styles.active)}
            onClick={() => setActiveLeg(index)}
          >
            <div className={styles.itemIndex}>{index + 1}</div>
            <div className={clsx(styles.tooltip, styles.bottom)}>
              {renderLegLabel({
                depart: leg.departureAirport?.code || leg.departureCity?.code || '',
                arrival: leg.arrivalAirport?.code || leg.arrivalCity?.code || '',
                isRtl,
              })}
            </div>
            <div className={styles.multiCityItemContent}>
              {renderLegLabel({
                depart: leg.departureAirport?.code || leg.departureCity?.code || '',
                arrival: leg.arrivalAirport?.code || leg.arrivalCity?.code || '',
                isRtl,
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MultiCityLegSelector;
